import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Skin } from '../../../shared/interfaces/click.interfaces';
import { Observable } from 'rxjs';

const basePath = '/dealer/skin';

@Injectable({
  providedIn: 'root'
})

export class DealerSkinService {
  constructor(private http: HttpClient) { }

  // Gets the skin settings for the current dealer
  getSkin(): Observable<Skin> {
    return this.http.get<Skin>(`${basePath}`);
  }

  // Updates the skin settings for the current dealer
  updateSkin(payload: Skin): Observable<Skin> {
    const body = {
      id: payload.id,
      primary_color: payload.primary_color,
      secondary_color: payload.secondary_color,
      logo_url: payload.logo_url
    };
    return this.http.post<Skin>(`${basePath}`, body);
  }

}
